module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Repeat-831f5924d2fb2af02b9056caed8419e1.svg";